//
//
//
//
//
//
//
//
//


import KCircularLoader from '../loaders/KCircularLoader';

export default {
  name: 'ContentRendererLoading',
  components: {
    KCircularLoader,
  },
};

